export const CLIENT_ID     = 'SPCGCBMXAIUCDAL1JJHXB0OWEIVIWZGKWYCPFQNPAUDZCNQH'
export const CLIENT_SECRET = '2IGTREZMXLUYXYIELZ1P4FEQ0VSMXX5DY2GALBQL0NPD34LC'
export const APP_VERSION   = '20191106'
export const AUTHORIZATION_CODE = window.location.href.match(/code=([^&]*)/)
